export default {"src":"/newStatic/_next/static/media/box.1dffb9e9.svg","height":61,"width":58};